import { PayloadAction } from '@reduxjs/toolkit';
import { BurstSlice, EDITABLE_COLUMN, rowStructure } from './types';
import { DURATION_SECONDS } from '../../../constants';

export const updateRowReducer = (
  state: BurstSlice,
  action: PayloadAction<{
    burst: DURATION_SECONDS;
    rowId: number;
    data: any[];
  }>
) => {
  const { burst, rowId, data } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      rows: state[burst].rows.map((row, index) =>
        index === rowId ? data : row
      )
    }
  };
};

export const setAllRowsReducer = (
  state: BurstSlice,
  action: PayloadAction<{ burst: DURATION_SECONDS; rows: rowStructure[] }>
) => {
  const { burst, rows } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      rows
    }
  };
};

export const setEditableCellReducer = (
  state: BurstSlice,
  action: PayloadAction<{ burst: EDITABLE_COLUMN }>
) => {
  const { burst } = action.payload;

  let fields = {
    [EDITABLE_COLUMN.BUDGET]: false,
    [EDITABLE_COLUMN.TARPS]: false,
    [EDITABLE_COLUMN.IMPACT]: false
  };

  switch (burst) {
    case EDITABLE_COLUMN.BUDGET:
      fields[EDITABLE_COLUMN.BUDGET] = true;
      break;
    case EDITABLE_COLUMN.TARPS:
      fields[EDITABLE_COLUMN.TARPS] = true;
      break;
    case EDITABLE_COLUMN.IMPACT:
      fields[EDITABLE_COLUMN.IMPACT] = true;
      break;
  }

  const updatedColumns = state.columns.map((column) => {
    const fieldKey = column.field as EDITABLE_COLUMN;
    if (fields.hasOwnProperty(fieldKey)) {
      return { ...column, editable: fields[fieldKey] };
    }
    return column;
  });

  return {
    ...state,
    columns: updatedColumns
  };
};

export const updateBudgetReducer = (
  state: BurstSlice,
  action: PayloadAction<{ budget: number; burst: DURATION_SECONDS }>
) => {
  const { budget, burst } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      budget: budget
    }
  };
};

export const updateTarpsReducer = (
  state: BurstSlice,
  action: PayloadAction<{ tarps: number; burst: DURATION_SECONDS }>
) => {
  const { tarps, burst } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      tarps: tarps
    }
  };
};

export const updateImpactReducer = (
  state: BurstSlice,
  action: PayloadAction<{ impact: number; burst: DURATION_SECONDS }>
) => {
  const { impact, burst } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      impact: impact
    }
  };
};

export const updateTotalCalculatedBudgetReducer = (
  state: BurstSlice,
  action: PayloadAction<{
    calculatedTotalBudget: number;
    burst: DURATION_SECONDS;
  }>
) => {
  const { calculatedTotalBudget, burst } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      calculatedTotalBudget
    }
  };
};

export const updateTotalCalculatedImpactsReducer = (
  state: BurstSlice,
  action: PayloadAction<{
    calculatedTotalImpact: number;
    burst: DURATION_SECONDS;
  }>
) => {
  const { calculatedTotalImpact, burst } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      calculatedTotalImpact
    }
  };
};

export const updateTotalCalculatedTarpsReducer = (
  state: BurstSlice,
  action: PayloadAction<{
    calculatedTotalTarps: number;
    burst: DURATION_SECONDS;
  }>
) => {
  const { calculatedTotalTarps, burst } = action.payload;
  return {
    ...state,
    [burst]: {
      ...state[burst],
      calculatedTotalTarps
    }
  };
};
